import BasicResources from './basic-resources';

// The Resources class provides a set of static fields, one for each resource
// needed by the application. Users should generally call its initialise() method, to set
// up the environment and create all of the resources the application will use.

// In some (hopefully, rare) situations, it may be required that the environment is provided
// from a parent application. In these situations, call createResources(parentEnv) directly,
// and pass it the Resources.env object that is the environment required.
class Resources {
  static createResources(parentEnv) {
    const CLASSROOM_REPORT_API = '@ClassroomReportApi';
    const USER_PORTAL_API = '@UserPortalGateway';
    if (parentEnv) {
      Resources.env = parentEnv;
    }

    Resources.getClassrooms = Resources.env
      .resource('getClassrooms')
      .baseUrl(CLASSROOM_REPORT_API)
      .service('classroll/product/{productId}');
    Resources.getResultsData = Resources.env
      .resource('getResultsData')
      .baseUrl(CLASSROOM_REPORT_API)
      .service('results-manager');
    Resources.classResultsData = Resources.env
      .resource('classResultsData')
      .baseUrl(CLASSROOM_REPORT_API)
      .service('results-manager/classes/{classId}');
    Resources.groupResultsData = Resources.env
      .resource('groupResultsData')
      .baseUrl(CLASSROOM_REPORT_API)
      .service('assigned-results/classroom/{classroomId}/groupId/{groupId}');
    Resources.topicResultsData = Resources.env
      .resource('topicResultsData')
      .baseUrl(CLASSROOM_REPORT_API)
      .service(
        'results-manager/classes/{classId}/groups/{groupId}/topics/{topicId}'
      );

    Resources.restrictActivities = Resources.env
      .resource('restrictActivities')
      .baseUrl(CLASSROOM_REPORT_API)
      .service(
        'assign/restrict/{isRestricted}/classroom/{classId}/group/{groupId}'
      );
    Resources.reassignActivities = Resources.env
      .resource('reassignActivities')
      .baseUrl(CLASSROOM_REPORT_API)
      .service(
        'results-manager/students-and-activities/classroom/{classroomId}/group/{groupId}/topic/{topicId}'
      );
    Resources.getcourseTopics = Resources.env
      .resource('getcourseTopics')
      .baseUrl(CLASSROOM_REPORT_API)
      .service('/course/{courseId}');

    Resources.getAssignments = Resources.env
      .resource('getAssignments')
      .baseUrl(CLASSROOM_REPORT_API)
      .service('assignments/classrooms/{classroomId}/groups/{groupId}');

    Resources.assign = Resources.env
      .resource('assign')
      .baseUrl(CLASSROOM_REPORT_API)
      .service('/assign/classroom/{classroomId}/group/{groupId}');

    Resources.unassign = Resources.env
      .resource('unassign')
      .baseUrl(CLASSROOM_REPORT_API)
      .service('/unassign/classroom/{classroomId}/group/{groupId}');

    Resources.unassignAll = Resources.env
      .resource('unassignAll')
      .baseUrl(CLASSROOM_REPORT_API)
      .service('/unassign-all/classroom/{classroomId}/group/{groupId}');

    Resources.getStartDatePreference = Resources.env
      .resource('getStartDatePreference')
      .baseUrl(USER_PORTAL_API)
      .service('preferences/activity-start-date');

    Resources.getDueDatePreference = Resources.env
      .resource('getEndDatePreference')
      .baseUrl(USER_PORTAL_API)
      .service('preferences/activity-due-date');

    Resources.getStudentActivitiesByActivityId = Resources.env
      .resource('getStudentActivitiesByActivityId')
      .baseUrl(CLASSROOM_REPORT_API)
      .service('report/student-single-activity-overview');

    Resources.getStudentResult = Resources.env
      .resource('getStudentResult')
      .baseUrl(CLASSROOM_REPORT_API)
      .service('report/student-course-activities-overview');

    Resources.getChartResult = Resources.env
      .resource('getChartResult')
      .baseUrl(CLASSROOM_REPORT_API)
      .service(
        '/report/group-results-overview/classrooms/{classroomId}/groups/{groupId}'
      );
  }

  // Initialise the environment and resources, based on the provided
  // environment name.  We return the environment so the caller has
  // access to everything, in particular the authToken if one was
  // passed in the query parameters.

  static initialise(envName, credentials) {
    Resources.env = BasicResources.initialise(envName, credentials);
    Resources.createResources();
    return Resources.env;
  }
}

export default Resources;



// WEBPACK FOOTER //
// ./helpers/resources.js